import Homepage from '@/pages/user/Homepage.vue'
import RedirectionPageOTP from '@/pages/user/RedirectionPageOTP.vue'
// import PageAxepta from '@/pages/axepta/PageAxepta.vue'
import PageLoading from '@/components/common/spinner.vue'

export default [
  {
    path: '/profile/',
    component: require('@/pages/user/CMProfile.vue').default
  },
  {
    path: '/profile/edit',
    component: require('@/pages/user/CMProfileEdit.vue').default
  },
  {
    path: '/profile/changePassword',
    component: require('@/pages/user/CMChangePassword.vue').default
  },
  {
    path: '/login/',
    component: require('@/pages/user/CMLogin.vue').default
  },
  {
    path: '/OTP/:email/:otp/:ressource',
    component: RedirectionPageOTP
  },
  {
    path: '/register/:FirstName/:LastName/:Login/:Password',
    component: require('@/pages/user/CMRegister.vue').default
  },
  {
    path: '/register/',
    component: require('@/pages/user/CMRegister.vue').default
  },
  {
    path: '/home/',
    component: Homepage
  },
  // {
  //   path: '/axepta/',
  //   component: PageAxepta
  // },
  {
    path: '/loading/',
    component: PageLoading
  }
]
